import "core-js/stable";
import "regenerator-runtime/runtime";

import Vue from 'vue'

import './assets/style.scss'
import './plugins/bootstrap-vue'
import './plugins/fontawesome'
import App from './App.vue'
import router from './router'

import axios from 'axios'


// Components
import Pageheader from './components/Pageheader.vue'
Vue.component('pageheader', Pageheader);

import VueBarcode from 'vue-barcode';
Vue.component('barcode', VueBarcode);

import VueTheMask from 'vue-the-mask'
Vue.use(VueTheMask)



Vue.config.productionTip = process.env.NODE_ENV === 'development'


// Axios / Https config
Vue.prototype.$http = axios

const teknobingoApi = axios.create({
    baseURL: process.env.VUE_APP_TEKNOBINGO_API_URL
})

Vue.prototype.$api = teknobingoApi

// Store
import store from '@/store'

if (localStorage.hasOwnProperty("state")) {
    store.state = JSON.parse(localStorage.state);
}
else {
    localStorage.state = JSON.stringify(store.state);
}

Vue.prototype.$store = store;
if (store.state.token) teknobingoApi.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.token;

// Throw out users without auth on refresh
teknobingoApi.get('/ping/')
    .catch((response) => { });

// Throw out users without auth on new data fetch
teknobingoApi.interceptors.response.use(
    (response) => {
        return response;
    }, (error) => {
        if (error.response.status == 401) {
            store.clear();
            // ["/logginn", "/meldinn"].contains(router.currentRoute.path)
            if (router.currentRoute.meta.auth) router.replace('/logginn');
        }

        return Promise.reject(error);
    }
);






// Router auth check
router.beforeEach((to, from, next) => {
    // To route with auth kick if not logged in
    if (to.matched.some(record => record.meta.auth)) {
        // Not logged in
        if (!store.state.user) {
            next({
                path: '/logginn',
                params: { nextUrl: to.fullPath }
            })
        }
        // Not verified
        else if (!store.state.user.verified && to.name !== 'verification') {
            next({
                path: '/verifisering',
            })

        }
        else {
            next()
        }
    }
    // Disallow guest routes for logged in users
    else if (to.matched.some(record => record.meta.guest)) {
        if (store.state.user) {
            next({
                path: '/'
            })
        }
        else {
            next()
        }
    }
    else {
        next()
    }
})


// Mixins
import bankIdentifiers from '@/assets/bank-identifiers.json';

Vue.mixin({
    methods: {
        accountNumber(s) {
            if (s == null) return null;
            let t = s.replace(/\s/g, '');
            return /^(\d{4})(\d{2})(\d{5})$/.test(t);
        },
        getBankName(accountNumber) {
            accountNumber = String(accountNumber)
            if (accountNumber && this.accountNumber(accountNumber)) {
                let match = accountNumber.match(/(\d{4}).*/);
                let id = match && match[1] ? match[1] : '';

                return bankIdentifiers[id] ? bankIdentifiers[id] : 'Den banken kjenner vi ikke til';
            }
            else return '...';
        },
        showNotification(title, content, variant = 'success') {
            this.$bvToast.toast(content, {
                title: title,
                autoHideDelay: 3000,
                appendToast: true,
                variant: variant
            })
        },

    }
});



new Vue({
    router,
    render: h => h(App)
}).$mount('#app')
